

<div class="mainGrid" fxLayout="column" fxLayoutAlign="start start" >


    <div class="Pageheader" >
        <p>SourceLink - New Item Report</p>
        <p>Store: {{_storeListService.pickedIdentity}}</p>
    </div>
        <div class="searchBar" fxLayout="row">
            <kendo-datepicker class="datepicker"
                    [(value)]="value"
                    [disabledDates]="disableDates"></kendo-datepicker>
            <app-mcl-button class="sub-button" [text]="'Search'" (buttonPressed)="searchByDate()" primary="true"></app-mcl-button>
        </div>

        <div class="dataGrid">
            <app-report-common [columns]="columns" [data]="gridData" [headerTemplate]="headerTemplate" [loading]="loading"
                               [filename]="'NewItem-Report.pdf'" [excelExportOptions]="{ sheetName: 'New Item Report', exportName: 'New_item_report.xlsx', exportHeader: 'SourceLink - New Item Report', storeName: _storeListService.pickedIdentity }" ></app-report-common>
        </div>
</div>


<ng-template #headerTemplate>
        <div class="header" >
            <p>SourceLink - New Item Report</p>
            <p>Store: {{_storeListService.pickedIdentity}}</p>
            <p>From: {{value | date }}</p>
        </div>
</ng-template>
<div kendoDialogContainer></div>
